export const SITE_URL = "https://superbuy.wtf";